import { put, takeLeading } from "redux-saga/effects";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.team.IDeleteTeamMember) {
    yield post("/delete-team-user", {
        team_id: action.teamId,
        email: action.email,
    });
    yield put({
        type: "com.sage.actions.team.IFetchTeamMembers",
        teamId: action.teamId,
        email: action.email,
    } as sage.actions.team.IFetchTeamMembers);
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.team.IDeleteTeamMember", execute);
}
